<template>
  <div class="page-goods">
    <div class="page-content">
      <!-- <a-layout> -->
        <!-- <div class="page-gdHder">
          <a-layout-header>
            <div class="page-tab">
              <a-tabs :activeKey="tabKey" @change="callback">
                <a-tab-pane
                  :tab="$tc('lang.menuList.Product_Inspection')"
                  key="1"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.menuList.Factory_Assessment')"
                  key="2"
                ></a-tab-pane>
                <a-tab-pane
                  :tab="$tc('lang.menuList.Loading_Supervision')"
                  key="3"
                ></a-tab-pane>
              </a-tabs>
            </div>
          </a-layout-header>
        </div> -->
        <!-- <a-layout> -->
          <!-- <div class="page-sider">
            <a-layout-sider>
              <div class="page-imageGods" />
              <p class="page-pGoods">
                {{ $tc('lang.menuList.Product_Inspection') }}
              </p>
              <p class="page-spnGoods">
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                  $tc('lang.menuGoodsSpace.Product_Inspection_text')
                }}
              </p>
            </a-layout-sider>
          </div> -->
          <div class="page-coGoods">
            <!-- <a-layout-content> -->
              <!--左侧头部-->
              <!-- <div class="page-heGd">
                <img src="./image/choutHer.jpg" class="page-imgChout" />
                <p class="page-pp">
                  {{ $tc('lang.menuList.Product_Inspection') }}
                </p>
              </div> -->
              <!-- <div class="page-hd" /> -->
              <!--==============左侧内容==================-->
              <div class="page-mainGoods">
                <div class="page-right">
                  <!--==============语言切换==================-->
                  <div class="page-langGd">
                    <span style="float: left; margin-top: 0.7vh"
                      >{{ $tc('lang.menuGoodsSpace.Language') }} :</span
                    >
                    <div class="page-butonGd">
                      <a-button
                        :type="orderReporttype === '1' ? 'primary' : 'default'"
                        class="page-rightButon"
                        @click="getLang('1')"
                        >{{ $tc('lang.menuGoodsSpace.Chinese') }}</a-button
                      >
                      <span class="page-span-renb">￥799/$115</span>
                      <a-button
                        :type="orderReporttype === '2' ? 'primary' : 'default'"
                        @click="getLang('2')"
                        >{{ $tc('lang.menuGoodsSpace.English') }}</a-button
                      >
                      <span class="page-span-renb">￥899/$139</span>
                    </div>
                  </div>
                  <div class="page-case">
                    <!--==============检验类型==================-->
                    <span style="float: left; margin-top: 0.7vh"
                      >{{ $tc('lang.menuGoodsSpace.Inspection_type') }} 
                      :</span
                    >
                    <div class="page-btGd">
                      <a-button
                        :type="orderType === '1' ? 'primary' : 'default'"
                        class="page-rightButon"
                        @click="getGoodsType('1')"
                        >{{
                          $tc('lang.menuGoodsSpace.Mid_Term_Inspection')
                        }}</a-button
                      >
                      <a-button
                        :type="orderType === '2' ? 'primary' : 'default'"
                        class="page-rightButon"
                        @click="getGoodsType('2')"
                        >{{
                          $tc('lang.menuGoodsSpace.Final_Inspection')
                        }}</a-button
                      >
                      <!-- <a-button
                        :type="orderType === '3' ? 'primary' : 'default'"
                        @click="getGoodsType('3')"
                        >{{
                          $tc('lang.menuGoodsSpace.Fabric_Inspection')
                        }}</a-button
                      > -->
                    </div>
                    <!--==============表单内容==================-->
                   
                  </div>
                  <keep-alive>
                      <router-view />
                    </keep-alive>
                </div>
              </div>
            <!-- </a-layout-content> -->
          </div>
        <!-- </a-layout> -->
      <!-- </a-layout> -->

    </div>
  </div>
</template>

<script>
export default {
  name: 'goods',
  data() {
    return {
      tabKey: '1',
      formLayout: 'horizontal',
      id:''
    };
  },
  watch: {
    $route() {
      this.getUrlTime();
    },
  },
  // 数据状态处理全局
  computed: {
    orderReporttype: {
      get() {
        return this.$store.state.downOrder.orderReporttype;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          orderReporttype: value,
        });
      },
    },
    orderType: {
      get() {
        return this.$store.state.downOrder.orderType;
      },
      set(value) {
        this.$store.commit('downOrder/save', {
          orderType: value,
        });
      },
    },
  },
  created() {
    this.getUrlTime();
    const url = window.location.href;
    const theRequest = new Object();
    // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
    if (url.indexOf('?') != -1) {
      //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
      const str = url.substr(url.indexOf('?') + 1);
      const strs = str.split('&');
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
      }
    }
    this.id = theRequest.id
    console.log('theRequest:', theRequest);

    // 获取订单数据
    if (theRequest.type === '2') {
      this.dataList();
    }
  },
  methods: {
    /*验货，验厂，监装:路由切换跳转路径*/
    callback(key) {
      if (key === '1') {
        this.$router.push('/goods');
      }
      if (key === '2') {
        this.$router.push('/factory');
      }
      if (key === '3') {
        this.$router.push('/supervision');
      }
    },
    // 获取订单数据
    dataList() {
      const url = window.location.href;
      const theRequest = new Object();
      // 取是否以问号(?)为下标如果有者返回该值的下标，如果没有就返回-1
      if (url.indexOf('?') != -1) {
        //截取字符串 以问号(?)开始在进行加1前进一个的下标，以那个下标为准开始截取
        const str = url.substr(url.indexOf('?') + 1);
        const strs = str.split('&');
        for (let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
        }
      }
      this.loading = true;
      this.$http
        .post('/hzwmj/workorder/selectById', {
          id: theRequest.id,
        })
        .then((data) => {
          if (data != null) {
            const reastData = data.data;
            const workorder = reastData.workorder;
            // 语言
            this.orderReporttype = workorder.orderReporttype;
            // 服务类型
            this.orderType = workorder.orderType;
            this.productNumber=workorder.productNumber
            this.productNumber1=workorder.productNumber1
            this.Inspection_Level=workorder.Inspection_Level
            this.orderFabrileveltwo=workorder.orderFabrileveltwo
            this.orderFabrilevelthree=workorder.orderFabrilevelthree
          }
        })
        .catch(() => {
          this.data = [];
          this.total = 0;
          this.loading = false;
        });
    },
    /*语言切换*/
    getLang(key) {
      //1（中文）、2（英文）
      if (key === '1') {
        this.orderReporttype = '1';
        console.log(this.$store.state.downOrder);
      }
      if (key === '2') {
        this.orderReporttype = '2';
        console.log(this.$store.state.downOrder);
      }
    },
    /*检验类型切换*/
    getGoodsType(key) {
      if (key === '1') {
        this.orderType = key;
        this.$router.push('/goods/start');
      }
      if (key === '2') {
        this.$router.push('/goods/centre');
        this.orderType = key;
      }
      if (key === '3') {
        this.$router.push('/goods/end');
       
        this.orderType = key;
      }
    },
    /*中期,尾期,面料路径方法*/
    getUrlTime() {
      const pathSegment = location.pathname.split('/').filter((i) => i);
      this.urlName = [];
      console.log(pathSegment);
      for (let j = 0; j < pathSegment.length; j++) {
        console.log('${pathSegment[j]}', `${pathSegment[j]}`);
        console.log('${pathSegment[j]}', typeof `${pathSegment[j]}`);
        if (
          `${pathSegment[j]}` === 'start'
          // ||
          // `${pathSegment[j]}` === 'goods'
        ) {
          this.orderType = '1';
        }
        if (`${pathSegment[j]}` === 'centre') {
          this.orderType = '2';
        }
        if (`${pathSegment[j]}` === 'end') {
          this.orderType = '3';
        }
      }
    },
  },
};
</script>

<style lang="less">
/deep/ .ant-layout{
  background: #f0f2f5;
  padding: 0px;
}
.page-goods {
  .page-content {
    // border-left: 3px solid #f0f2f5;
    // border-right: 2px solid #f0f2f5;
    // border-bottom: 2px solid #a7a7a7;
    border-radius: 10px;
    margin-top: 3%;
    background-color: #fff;
    // .ant-layout {
    //   height: calc(100vh - 209px);
    // }
    .page-gdHder {
      .ant-layout-header {
        // padding: 0 25px;
        background-color: #fff;
        height: 44px;
      }
    }
    .page-tab {
      .ant-tabs-nav .ant-tabs-tab-active {
        background-color: #e9eef3;
      }
      .ant-tabs-nav {
        float: left;
      }
    }
    /*==========右侧===========*/
    .page-sider {
      overflow-y: auto;
      background: #fff;
      width: 250px;
      padding: 20px;
      .ant-layout-sider {
        background-color: #fff;
      }
      .page-imageGods {
        margin-top: 40%;
        // margin-left: 22%;
        height: 163px;
        width: 186px;
        background-size: 100%;
        background-image: url(./image/goos2x.png);
      }
      .page-spnGoods {
        color: rgba(155, 150, 150, 1);
        font-size: 16px;
        // margin-left: 20%;
        width: 100%;
      }
      /*适配右侧屏幕分辨率*/
      @media all and (min-width: 1230px) and (max-width: 1500px) {
        .page-imageGods {
          margin-top: 60%;
          // margin-left: 19%;
          height: 163px;
          width: 186px;
          background-image: url(./image/goos2x.png);
        }
        .page-spnGoods {
          color: rgba(155, 150, 150, 1);
          font-size: 16px;
          // margin-left: 15%;
          width: 100%;
        }
      }
      @media screen and (max-width: 1200px) {
        .page-imageGods {
          margin: 60% 0 auto;
          height: 163px;
          width: 185px;
          background-image: url(./image/goos2x.png);
        }
        .page-spnGoods {
          color: rgba(155, 150, 150, 1);
          font-size: 13px;
          // margin-left: 19%;
          width: 65%;
        }
      }
      .page-pGoods {
        padding-top: 20px;
        font-size: 30px;
        // @media all and (min-width: 1230px) and (max-width: 1500px) {
        //   margin-left: 30%;
        // }
        @media screen and (max-width: 1200px) {
          margin-left: -8%;
        }
        /*margin-left: 25%;*/
        // margin-left: 50%;
        font-weight: 800;
        color: rgba(80, 80, 80, 1);
      }
    }
    /*==============左侧===============*/
    .page-coGoods {
      overflow-y: auto;
      // background-color: #fff;
      background-color: #fff;
      // width: 89%;
      /*左侧头部*/
      .page-hd {
        border-bottom: 1px solid #a7a7a7;
        width: 95%;
        margin: 1px auto;
      }
      .page-heGd {
        display: flex;
        .page-pp {
          margin-top: 18px;
          font-weight: 900;
          font-size: 21px;
        }
        .page-imgChout {
          height: 60px;
          width: 60px;
          margin-left: 26px;
        }
      }
    }
  }
}
</style>
